import styled from "@emotion/styled";
import { Spin } from "antd5";

export interface FilterFormResultsProps {
  totalResults: number;
  sortedByField?: string;
  isLoading?: boolean;
}

function FilterFormResults({ totalResults, sortedByField, isLoading }: FilterFormResultsProps) {
  return (
    <FilteredResultsInfo>
      <FilterBarItem>
        {isLoading ? <Spin size="small" /> : totalResults}
        <FilterBarText>Results</FilterBarText>
      </FilterBarItem>
      {sortedByField && (
        <>
          <FilterBarText>•</FilterBarText>
          <FilterBarItem>
            <FilterBarText>Sorted by </FilterBarText>
            {sortedByField}
          </FilterBarItem>
        </>
      )}
    </FilteredResultsInfo>
  );
}

export default FilterFormResults;

const FilteredResultsInfo = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

const FilterBarText = styled.span(({ theme }) => ({
  color: theme.colors.sysTextSecondary,
}));

const FilterBarItem = styled.div({
  display: "flex",
  columnGap: 5,
  alignItems: "baseline",
});
